import React, { Component } from "react";
import Account from "../components/Account";
import { languages } from "../constants/languages";
import { withRouter } from "react-router-dom";

class AccountContainer extends Component {
  state = {
    userData: {},
    userDataLoaded: false,
    changePasswordDialogOpen: false,
    currentPassword: "",
    password: "",
    passwordConfirm: "",
    errorMessage: "",
    errorMessageNew: "",
    passwordChangeSuccess: false,
    sent: false,
    buttonDisabled: false,
    errorMessageResetEmail: "",
    deleteAccountDialogOpen: false,
    reAuthPassword: "",
    errorMessageReAuth: "",
  };

  handleDeleteAccount = () => {
    const user = window.firebase.auth().currentUser;
    const credential = window.firebase.auth.EmailAuthProvider.credential(
      user.email,
      this.state.reAuthPassword
    );
    user
      .reauthenticateWithCredential(credential)
      .then(() => {
        this.setState({ errorMessageReAuth: "" });
        user
          .delete()
          .then(function () {
            // User deleted.
          })
          .catch(function (error) {
            // An error happened.
          });
      })
      .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        if (errorCode === "auth/invalid-email") {
          errorMessage = languages.login.invalidEmail;
        } else if (errorCode === "auth/user-not-found") {
          errorMessage = languages.login.userNotFound;
        } else if (errorCode === "auth/wrong-password") {
          errorMessage = languages.login.wrongPassword;
        }
        this.setState({ errorMessageReAuth: errorMessage });
      });
  };

  handleTimezoneChange = (e) => {
    e.preventDefault();
    const db = window.firebase.firestore();
    let timezone = e.target.value;

    db.collection("tournaments")
      .where("uid", "==", this.props.user.uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          db.collection("tournaments")
            .doc(doc.id)
            .update({ timezone: timezone })
            .catch((error) => {
              console.log(error.message, doc.id);
            });
        });

        db.collection("users").doc(this.props.user.uid).update({
          timezone: timezone,
        });
      });
  };

  handleBack = () => {
    this.props.history.push("/");
  };

  toggleChangePasswordDialog = () => {
    this.setState({
      changePasswordDialogOpen: !this.state.changePasswordDialogOpen,
    });
  };

  toggleDeleteAccountDialog = () => {
    this.setState({
      deleteAccountDialogOpen: !this.state.deleteAccountDialogOpen,
    });
  };

  UNSAFE_componentWillMount = () => {
    this.unsubscribeUser = window.firebase
      .firestore()
      .collection("users")
      .doc(this.props.user.uid)
      .onSnapshot((doc) => {
        if (doc.exists) {
          this.setState({ userData: doc.data(), userDataLoaded: true });
        }
      });
  };

  componentWillUnmount = () => {
    this.unsubscribeUser();
  };

  handleChange = (event) => {
    let toUpdate = {};
    toUpdate[event.target.name] = event.target.value;
    this.setState(toUpdate);
  };

  handleNameChange = (event) => {
    let toUpdate = {};
    toUpdate["firstName"] = event.target.value;
    window.firebase
      .firestore()
      .collection("users")
      .doc(this.props.user.uid)
      .update(toUpdate);
  };

  validateForm = () => {
    return (
      this.state.password.length > 5 &&
      this.state.password === this.state.passwordConfirm
    );
  };

  handleChangePassword = () => {
    this.setState({ errorMessage: "", errorMessageNew: "" });
    let credential = window.firebase.auth.EmailAuthProvider.credential(
      this.props.user.email,
      this.state.currentPassword
    );
    this.props.user
      .reauthenticateAndRetrieveDataWithCredential(credential)
      .then(
        function () {
          // User re-authenticated.
          if (this.validateForm()) {
            this.props.user
              .updatePassword(this.state.password)
              .then(
                function () {
                  // Update successful.
                  this.setState({
                    changePasswordDialogOpen: false,
                    passwordChangeSuccess: true,
                  });
                }.bind(this)
              )
              .catch(function (error) {
                // An error happened.
              });
          } else {
            let errorMessage = "";
            if (this.state.password.length < 6) {
              errorMessage = languages.login.passwordTooShort;
            } else if (this.state.password !== this.state.passwordConfirm) {
              errorMessage = languages.login.passwordsNotSame;
            }
            this.setState({ errorMessageNew: errorMessage });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          // An error happened.
          var errorCode = error.code;
          var errorMessage = error.message;
          if (errorCode === "auth/invalid-email") {
            errorMessage = languages.login.invalidEmail;
          } else if (errorCode === "auth/user-not-found") {
            errorMessage = languages.login.userNotFound;
          } else if (errorCode === "auth/wrong-password") {
            errorMessage = languages.login.wrongPassword;
          }
          this.setState({ errorMessage: errorMessage });
        }.bind(this)
      );
  };

  sendPasswordResetEmail = (e) => {
    e.preventDefault();
    this.setState({ buttonDisabled: true, errorMessageResetEmail: "" });
    if (this.state.sent === false) {
      window.firebase
        .auth()
        .sendPasswordResetEmail(this.props.user.email)
        .then(
          function () {
            this.setState({ sent: true });
          }.bind(this)
        )
        .catch(
          function (error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            if (errorCode === "auth/invalid-email") {
              errorMessage = languages.login.invalidEmail;
            } else if (errorCode === "auth/user-not-found") {
              errorMessage = languages.login.userNotFound;
            }
            this.setState({
              errorMessageResetEmail: errorMessage,
              buttonDisabled: false,
            });
          }.bind(this)
        );
    }
  };

  render() {
    return (
      <Account
        user={this.props.user}
        {...this.state}
        toggleChangePasswordDialog={this.toggleChangePasswordDialog}
        handleChange={this.handleChange}
        handleNameChange={this.handleNameChange}
        handleChangePassword={this.handleChangePassword}
        handleBack={this.handleBack}
        handleForgotPasswordClick={this.handleForgotPasswordClick}
        sendPasswordResetEmail={this.sendPasswordResetEmail}
        handleTimezoneChange={this.handleTimezoneChange}
        toggleDeleteAccountDialog={this.toggleDeleteAccountDialog}
        handleDeleteAccount={this.handleDeleteAccount}
      />
    );
  }
}

export default withRouter(AccountContainer);
